<template>
    <AppLayout class="custom-formulation" :class="colleagueFormulation ? 'disabled' : ''">
        <BaxHeaderBannerSimple :user="this.$store.state.auth.user" :containerClass="'full-page'">
        Custom Formulation
        </BaxHeaderBannerSimple>
        <main class="formulation-create-form">
            <div class="bax-section">
                <div class="container full-page" v-if="asyncDataReady">
                    <div class="intro">
                        <h3>Create a Custom PN Formulation</h3>
                    </div>
                    <div class="steps-container">
                         <ul>
                            <li class="step-item" :class="{ 'past': step.number < currentStep , 'active': step.number == currentStep }" v-for="(step, index) in formSteps" :key="index">
                                <a href="#">
                                    <span class="dot"></span>
                                    <span class="title">{{step.title}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="form-container">
                        <div class="form-step-container active" v-for="(step, index) in formSteps" :key="index" >
                            <component v-if="step.number == currentStep" :is="step.componentName" :formData="formData" :viewMode="colleagueFormulation" :formulationsData="formulationsData" :formulationRecordId="formulationRecordId" :preloadedFormData="preloadedFormData" :basisList="basisList" :ref="'step' + step.number" @validation_response="onValidationResponse" @set_preloaded_data="setPreloadedData" @change_bag="onChangeBag"></component>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </AppLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import tpnUtilsMixin from '@/mixins/tpnUtilsMixin';
import AppLayout from '@/components/layout/AppLayout.vue';
import BaxHeaderBannerSimple from '@/components/layout/BaxHeaderBannerSimple.vue';
import { scrollPageToTop, scrollPageToFirstError } from '@/core/helpers';
import FormStep1 from '@/views/Tpn/CustomFormulationCreate/FormStep1.vue';
import FormStep2 from '@/views/Tpn/CustomFormulationCreate/FormStep2.vue';
import FormStep3 from '@/views/Tpn/CustomFormulationCreate/FormStep3.vue';
import FormStep4 from '@/views/Tpn/CustomFormulationCreate/FormStep4.vue';
import CustomFormulationService from '@/core/api/tpn/customFormulation.service';

export default {
    name: 'CustomFormulationCreate',
    mixins: [tpnUtilsMixin],
    components: {
        AppLayout,
        BaxHeaderBannerSimple,
        FormStep1,
        FormStep2,
        FormStep3,
        FormStep4,
    },
    data() {
        return {
            formSteps: [
                {
                    number: 1,
                    componentName: 'FormStep1',
                    title: 'Select type',
                },
                {
                    number: 2,
                    componentName: 'FormStep2',
                    title: 'Select base',
                },
                {
                    number: 3,
                    componentName: 'FormStep3',
                    title: 'Create formulation',
                },
                {
                    number: 4,
                    componentName: 'FormStep4',
                    title: 'Formulation submitted',
                },
            ],
            formData: {
                currentStep: 1,
                country: '',
                use: '',
                frequency: '',
                base: '',
                bag_details: '',
                patient_initials: '',
                patient_ref: '',
                bag_volume: '',
                comments: '',
                formulation: this.getDefaultFormulationStructure(),
                micronutrientsUnitToggle: false,
                micronutrientsUnit: 'microgram',
                selectedAminoAcidType: false,
                selectedGlucoseType: false,
                selectedLipidType: false,
                traceElementRecapTotals: [],
                status: '',
                stability: '',
                created_by_user_id: '',
                created_by_user_name: '',
                errors: {
                    bag: false,
                    aminoacid: false,
                    glucose: false,
                    lipids: false,
                    electrolytes: {},
                    trace_elements: [],
                    trace_elements_multi: [],
                    vitamins: [],
                    additives: {},
                },
            },
            formulationRecordId: false,
            currentStep: 1,
            asyncDataLoaded: false,
            asyncListLoaded: false,
            formulationsData: false,
            preloadedFormData: false,
            basisList: false,
            colleagueFormulation: false,
        };
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
        asyncDataReady() {
            if (this.asyncDataLoaded && this.asyncListLoaded) {
                return true;
            }

            return false;
        },
    },
    created() {
        scrollPageToTop();

        CustomFormulationService.getCustomFormulationInfo(this.$route.params.code)
        .then((res) => {
            const { data } = res;
            this.formulationsData = data.formulations;
            this.formData.country = data.country;
            if (data.existingFormData) {
                this.formData = data.existingFormData;
                this.currentStep = this.formData.currentStep;
                this.formulationRecordId = this.$route.params.code;
                this.preloadedFormData = true;
                this.status = 'saved';
                if (this.formData.created_by_user_id !== this.$store.state.auth.user.userId) {
                   this.colleagueFormulation = true;
                }
            }
            this.asyncDataLoaded = true;
        });

        CustomFormulationService.getCustomFormulationRecent('')
        .then((res) => {
            const { data } = res;
            this.basisList = data.list;
            this.asyncListLoaded = true;
        });
    },
    methods: {
        onChangeBag() {
            this.formData.formulation = this.getDefaultFormulationStructure();
            this.formData.bag_volume = '';
            this.formData.micronutrientsUnitToggle = false;
            this.formData.micronutrientsUnit = 'microgram';
            this.formData.selectedAminoAcidType = false;
            this.formData.selectedGlucoseType = false;
            this.formData.selectedLipidType = false;
            this.formData.traceElementRecapTotals = [];
            this.formData.status = '';
            this.formData.stability = '';
            this.formData.errors = {
                bag: false,
                aminoacid: false,
                glucose: false,
                lipids: false,
                electrolytes: {},
                trace_elements: [],
                trace_elements_multi: [],
                vitamins: [],
                additives: {},
            };
            this.preloadedFormData = false;

            this.formData.currentStep = 2;
            this.currentStep = 2;
        },
        onValidationResponse(response) {
            this.validForm = response;
            if (!this.validForm) {
                this.$nextTick(() => scrollPageToFirstError('form-error'));
            } else {
                this.currentStep += 1;
                if (this.currentStep > this.formSteps.length) {
                    this.currentStep = this.formSteps.length;
                }
                this.formData.currentStep = this.currentStep;
                scrollPageToTop();
            }
        },
        setPreloadedData(data) {
            // replace formdata with retrieve data, except some fields
            const originalFormData = this.formData;

            this.formData = data;
            // replace step 1 data
            this.formData.use = originalFormData.use;
            this.formData.frequency = originalFormData.frequency;
            // cleanup other fields
            this.formData.bag_details = 'Copy of ' + this.formData.bag_details;
            if (originalFormData.use === 'general') {
                this.formData.patient_initials = '';
                this.formData.patient_ref = '';
            }
            this.formData.currentStep = 3;
            this.currentStep = 3;
            this.formData.status = '';
            this.formData.stability = '';
            this.formData.created_by_user_id = '';
            this.formData.created_by_user_name = '';
            this.formulationRecordId = false;
            this.colleagueFormulation = false;
            this.preloadedFormData = true;
        },
    },
};
</script>
